/* ==========================================================================
   SearcherFli > Client > Openjaw > Row
   ========================================================================== */

/* Import modules */
const { toNode } = require('@bluekiri/alexandria/helpers/domHelpers');

const { initOrigin, destroyOrigin, renderOrigin } = require('./origin');
const { initDestination, destroyDestination, renderDestination } = require('./destination');
const { initCalendar, destroyCalendar, renderCalendar } = require('./calendar');
const { initRemoveButton, destroyRemoveButton, renderRemoveButton } = require('./remove');

const { OPENJAW } = require('../../../constants');

/* Create */
function createRow(instance, index = 0) {
    /* Data */
    const { calendar, literals, context } = instance.config;
    const { rows } = instance.store.select('openjaw');

    const dataOrigin = rows[index].origin;
    const dataDestination = rows[index].destination;
    const dataCalendar = {
        ...calendar,
        startDate: rows[index].calendar[0]
    };

    /* Template */
    return `
        <div class='searcher__row' data-row=${index}>
            ${renderOrigin({ value: dataOrigin }, literals, context)}
            ${renderDestination({ value: dataDestination }, literals, context)}
            ${renderCalendar({ calendar: dataCalendar, product: OPENJAW }, literals, context)}
            ${index >= 2 ? renderRemoveButton(context) : ''}
        </div>
    `;
}

/* Add */
function addRow(instance, index = 0) {
    const panel = instance;

    /* Template */
    const template = createRow(instance, index);

    /* Node */
    const node = toNode(template)[0];

    /* Append to DOM */
    instance.hooks.middle.insertBefore(node, instance.addButton.element.parentNode);

    /* Add to instance */
    panel.rows = [...(instance.rows || []).filter(item => item), { element: node, index }];

    /* Init */
    initRow(instance, index);
}

/* Init */
function initRow(instance, index) {
    /* Origin */
    initOrigin(instance, index);

    /* Destination */
    initDestination(instance, index);

    /* Calendar */
    initCalendar(instance, index);

    /* Remove */
    initRemoveButton(instance, index);
}

/* Destroy row by index */
function destroyRow(instance, index) {
    const panel = instance;

    /* Origin */
    destroyOrigin(instance, index);

    /* Destination */
    destroyDestination(instance, index);

    /* Calendar */
    destroyCalendar(instance, index);

    /* Remove */
    destroyRemoveButton(instance, index);

    /* Remove from DOM */
    instance.rows[index].element.parentNode.removeChild(instance.rows[index].element);

    /* Delete row from instance */
    delete panel.rows[index];
}

module.exports = {
    addRow,
    destroyRow
};
